/* eslint-disable */
import { icon, node } from "~/util/dom";

export interface IMyMapsPopupProps {
	cb?: (data: any) => void;
	name?: string;
	userClose?: boolean;
	closeSvg?: string;
	holderParent?: HTMLElement;
}

export interface IMyMapsPopupDOM {
	container: HTMLDivElement;
	cover: HTMLDivElement;
	holder: HTMLDivElement;
	closeBtn: HTMLButtonElement;
	// FIXME: tohle casem pryc, az vsichni, kdo z toho dedi budou taky TS a mit spravne otypovano
	[key: string]: HTMLElement;
}

let isOpen = false;

export default class MyMapsPopup {
	_opts: IMyMapsPopupProps;
	_dom: IMyMapsPopupDOM;
	_isOpen: boolean;

	constructor(opts: IMyMapsPopupProps) {
		this._opts = {
			name: "", // vlastni name, pak se prida do nazvu tridy
			userClose: true, // muze uzivatel zavrit okno sam? (pokud je false, tak musime zajistit, ze z okna vede nejaka cesta)
			closeSvg: "close",
			holderParent: document.body,
			...opts,
		};
		this._dom = {
			container: node("div", { className: "mymap-popup" }),
			cover: node("div", { className: "mymap-popup-cover" }),
			holder: node("div", { className: "mymap-popup-holder" }),
			closeBtn: node("button", { className: "close", type: "button" }),
		};
		this._isOpen = false;

		this._create();
	}

	/**
	 * Obal.
	 */
	getContainer() {
		return this._dom.container;
	}

	getCover() {
		return this._dom.cover;
	}

	destroy() {
		Mapy.Util.clear(this._dom.container);
	}

	handleEvent(e) {
		switch (e.type) {
			// kdyz je popup, nechceme, aby to propadlo az do body dropu
			case "drop":
				e.preventDefault();
				e.stopPropagation();
				break;
			case "click":
				if (this._opts.userClose && (e.target === this._dom.cover || e.target === this._dom.closeBtn || this._dom.closeBtn.contains(e.target))) {
					e.stopPropagation();
					this.close();
				}
				break;

			case "keydown":
				let keyCode = e.which || e.keyCode;

				if (this._opts.userClose && keyCode == 27) {
					e.stopPropagation();
					this.close();
				}
				break;
		}
	}

	/**
	 * Otevreni popupu pres tlacitko.
	 */
	open() {
		if (!isOpen) {
			this._opts.holderParent.appendChild(this._dom.holder);
			document.addEventListener("keydown", this);
			this._dom.cover.addEventListener("click", this);
			this._dom.holder.addEventListener("drop", this);
			this._dom.closeBtn.addEventListener("click", this);
			this._isOpen = true;
			isOpen = true;
			document.body.style.setProperty("overflow", "hidden");

			const activeElement = document.activeElement as HTMLElement;
			if (activeElement) { activeElement.blur(); }
			this._sendSignal("open");
		}
	}

	/**
	 * Zavreni popupu.
	 */
	close() {
		this._isOpen = false;
		this._dom.holder.remove();
		document.removeEventListener("keydown", this);
		this._dom.cover.removeEventListener("click", this);
		this._dom.holder.removeEventListener("drop", this);
		this._dom.closeBtn.removeEventListener("click", this);
		document.body.style.removeProperty("overflow");
		isOpen = false;
		this._sendSignal("close");
	}

	get isOpen() {
		return this._isOpen;
	}

	get closeButton() {
		return this._dom.closeBtn;
	}

	/**
	 * Vytvoreni popupu pro pridani.
	 */
	_create() {
		this._dom.holder.appendChild(this._dom.cover);
		this._dom.holder.appendChild(this._dom.container);

		if (this._opts.name) {
			this._dom.container.classList.add(this._opts.name);
		}

		// cudl na zavreni - pro zpetnou kompatibilitu ho vyrabime, i kdyz ho pak treba nepouzijeme
		this._dom.closeBtn.appendChild(icon(this._opts.closeSvg));

		if (this._opts.userClose) {
			this._dom.container.appendChild(this._dom.closeBtn);
		}
	}

	/**
	 * Poslani signalu - otevreni, zavreni editace, nastaveni slozky.
	 */
	_sendSignal(name: string, data?: any) {
		if (typeof this._opts.cb === "function") {
			this._opts.cb(Object.assign({
				name
			}, data));
		}
	}

	/**
	 * vlozit errorovy dom do predaneho kontejneru
	 */
	_addError(container: HTMLElement, text) {
		let p = Mapy.Util.node("p", { className: "error" }, text && typeof text == "string" ? text : "");
		if (text && typeof text != "string") {
			p.appendChild(text);
		}
		container ? container.appendChild(p) : this._dom.container.appendChild(p);
	}

	/**
	 * odebrani chybove hlasky z predaneho kontejneru
	 */
	_removeError(container) {
		let errors: Array<HTMLElement> = Array.from(container ? container.querySelectorAll(".error") : this._dom.editContainer.querySelectorAll(".error"));

		for (const error of errors) {
			error.remove();
		}
	}

}
